// Prefix needed for https://app.datadoghq.com/monitors/170680948
export const DATA_DOG_PREFIX = '[SHP-API Error]';
export const APPROVAL_ODDS_API_PATH = '/api/credit-cards/og/approval-odds';
export const errorConfigs = {
  MISSING_TOKEN: {
    logLevel: 'warn',
    message: 'Missing token error',
    status: 401,
  },
  TRANSUNION_ERROR: {
    logLevel: 'error',
    message: `${DATA_DOG_PREFIX} TransUnion service error`,
    status: 502,
  },
  SERVICE_ERROR: {
    logLevel: 'error',
    message: `${DATA_DOG_PREFIX} CCML service error`,
    status: 500,
  },
} as const;
